import { ApplicationRef, enableProdMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Observable } from 'rxjs';
import { AppModule } from 'src/app/app.module';
import { environment } from 'src/environments/environment';
import { printSubscribers, setup, track } from './util/observable-tracker';

const observableTrackerEnabled = false;
const canEnableObservableTracker = !environment.production && observableTrackerEnabled;

if (environment.production) {
  enableProdMode();
} else if (canEnableObservableTracker) {
  setup(Observable);
}

// https://github.com/angular/angular-cli/issues/8779#issuecomment-351583429
// https://github.com/angular/angular-cli/issues/8779#issuecomment-447394606
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((ref) => {
    if ('serviceWorker' in navigator) {
      if (environment.production) {
        navigator.serviceWorker.register('/ngsw-worker.js');
      }
    }
    if (!environment.production) {
      const applicationRef = ref.injector.get(ApplicationRef);
      const componentRef = applicationRef.components[0];
      enableDebugTools(componentRef);

      if (canEnableObservableTracker) {
        track();
        // In DevTools console call 'window.stopTracker()' to see results.
        (window as any).stopTracker = () => {
          ref.destroy();
          const subscribers = track(false);
          printSubscribers({
            ignoreStackFilterRe:
              /FocusKeyManager|MatSidenav|MatSelect|MatDrawer|OktaAuthGuard|TdLoadingService/,
            reportInnerSubscriptions: true,
            subscribers,
          });
        };
      }
    }
  })
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
